import {
	getSharesCashout,
    getSharesCashoutCount
} from '@/api/shares';

import Pagination from '@/components/Pagination';

export default {
	name: 'shares',
    components: {
		Pagination
	},
	data() {
		return {
			orderObj: { //订单列表
				list: [],
				total: 0,
				listLoading: false,
			},
            orderCount: { //数量
                withdrawUserNum: 0,
                withdrawTimes: 0,
                withdrawMoney: 0,
            },
            payDate: [],
			form: {
				pageNum: 1,
				pageSize: 10,
			}
		}
	},
	beforeCreate() {
        
	},
	created() {
		this.getOrderPage()
	},
	methods: {
		//获取订单列表
		getOrderPage() {
            if(this.payDate){
                this.form.startTimeYMD = this.payDate[0]
                this.form.endTimeYMD = this.payDate[1]
            }else{
                this.form.startTimeYMD = ''
                this.form.endTimeYMD = ''
            }
            this.orderObj.listLoading = true;
			//获取订单列表
			getSharesCashout(this.form).then(res => {
				this.orderObj.list = res.data.list;
                this.orderObj.total = res.data.total;
				this.orderObj.listLoading = false;

			})

            //获取订单统计
            getSharesCashoutCount({
                sharerTelnoLike: this.form.sharerTelnoLike,
                startTimeYMD: this.form.startTimeYMD,
                endTimeYMD: this.form.endTimeYMD
            }).then(res => {
                console.log(res)
                if(res.code == 200){
                    this.orderCount.withdrawUserNum = res.data.withdrawUserNum
                    this.orderCount.withdrawTimes = res.data.withdrawTimes
                    this.orderCount.withdrawMoney = res.data.withdrawMoney
                }
            });
		},
	}
}
